module.exports = __webpack_public_path__ + "p7_img2.jpg?d426e73be56bf262acd3e556c418212b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img2.jpg
// module id = 119
// module chunks = 0